import { PaginatedNotificationListResponseList } from 'libs/mona/api/src/lib/model';
import { ApiModels } from '@mona/api';

/**
 * Transforms API notification
 *
 * @param apiNotifications ApiModels.Notification[]
 */
export const transformApiNotificationsResponse = (
    apiNotifications: PaginatedNotificationListResponseList,
): PaginatedNotificationListResponseList.Model => {
    const model = ApiModels.PaginatedNotificationListResponseList.DTO.toModel(apiNotifications as any);
    return model;
};

export const transformApiNotifications = (
    apiNotifications: ApiModels.Notification[],
): ApiModels.Notification.Model[] => {
    return apiNotifications.map(apiNotifications => ApiModels.Notification.DTO.toModel(apiNotifications));
};

// export const transformToPartialApiPatient = (patient: Partial<Patient>): Partial<ApiModels.Patient> => {
//     const model = ApiModels.Patient.DTO.toApi(patient as any);
//     model.date_of_birth = format(new Date(model.date_of_birth), 'yyyy-MM-dd');
//     return compactObject(model);
